const colors = require("../../src/styles/colors");

module.exports = {
  siteTitle: "The Theory of Everything - A Categorical Foundation for knowledge", // <title>
  shortSiteTitle: "ToE", // <title> ending for posts and pages
  siteDescription: "A blog on the categorical Foundation for knowledge",
  siteUrl: "http://toe.catai.systems",
  pathPrefix: "",
  siteImage: "preview.jpg",
  siteLanguage: "en",
  // author
  authorName: "François Magnan",
  authorTwitterAccount: "frmagnan",
  // info
  infoTitle: "ToE",
  infoTitleNote: "Theory of Everything",
  // manifest.json
  manifestName: "A blog on categorical the foundations of knowledge",
  manifestShortName: "PersonalBlog", // max 12 characters
  manifestStartUrl: "/",
  manifestBackgroundColor: colors.background,
  manifestThemeColor: colors.background,
  manifestDisplay: "standalone",
  // contact
  contactEmail: "fmagnan@me.com",
  // social
  authorSocialLinks: [
    { name: "github", url: "https://github.com/magnan" },
    { name: "twitter", url: "https://twitter.com/frmagnan" },
    { name: "facebook", url: "https://www.facebook.com/francois.magnan.54/" }
  ]
};



// WEBPACK FOOTER //
// ./content/meta/config.js